import * as React from "react";
import { withRouter } from 'react-router-dom';
import * as Tools from "../../helpers/Tools";
import {get} from 'lodash';
import { logUI } from "../../api/andyliticsApi";
import { firstNameFirst } from "../../helpers/formatting";
import StaticHtmlContent from "../common/staticHtmlContent";

const DATE_FORMAT = Tools.getDateFormats();

 class Covid19ReviewNSubmit extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.formatTime = this.formatTime.bind(this);
        this.onGoNext = this.onGoNext.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Covid19ReviewNSubmit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    getDayOfWeek(x) {
        //debugger;
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        var weekday = new Array(7);
        weekday[0] = "SUN";
        weekday[1] = "MON";
        weekday[2] = "TUE";
        weekday[3] = "WED";
        weekday[4] = "THU";
        weekday[5] = "FRI";
        weekday[6] = "SAT";
        if (Object.prototype.toString.call(dt) === '[object Date]') {
            var strDay = weekday[dt.getDay()];
            return strDay;
        }
        return "Invalid Date";
    }

    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        const dayName = dt.getDate();
        let monthName = dt.getMonth() + 1;
        if (monthName < 10)
            monthName = "0" + monthName;       
        return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
    }

     formatTime(s) {
         let dateTime = s && s.split("T");
         const dt = new Date(s);
         const time = (dateTime && dateTime.length > 1) ? dateTime[1].split(":") : "00:00:00";
         if (time.length > 0) {
             dt.setHours(time[0], time[1]);
         }         
         const AMPM = dt.getHours() >= 12 ? "PM" : "AM";
         return `${(dt.getHours() > 12 ? dt.getHours() - 12 : dt.getHours())}:${dt.getMinutes().toString().padStart(2, "0").slice(-2)} ${AMPM}`;
    }

     onGoNext() {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    }

    render() {
        const { visit, currentUser, primaryUser, scheduleAppointmentForProxy, serverData, schedule, isFromSeeMore, providerMessage } = this.props;

        let patientName = (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : "");
        patientName = scheduleAppointmentForProxy ? currentUser ? primaryUser.eid === currentUser.eid ? firstNameFirst(primaryUser.displayName) : firstNameFirst(currentUser.displayName) : patientName : patientName;

        const address = visit.department.address;
        const location = address && (address.street1 || address.city) ? (address.street1 ? address.street1 + ', ' : '') + address.city + ', ' + address.state + ' ' + address.zip : "-";
        const locationDirections = address && (address.street1 || address.city) ? 'https://www.google.com/maps/place/' +
            (address.street1 ? address.street1 + ', ' : '') + (address.city ? address.city + ', ' : '') + (address.state ? address.state + ' ' : '') + (address.zip ? address.zip : '') : '#';
        const locationDirectionsTarget = address ? '_blank' : '_self';

        const appendVisit = visit.visitType.description.toLowerCase().indexOf("visit") >= 0 ? "" : " Visit";
        const appt = {
            visitType: visit.visitType.description + appendVisit,         
            timeString: visit.timeString? visit.timeString : this.formatTime(visit.startTime),
            DayString: visit.startTime && this.getDayOfWeek(visit.startTime),
            DateString: visit.startTime && this.date2str(visit.startTime)
        };
        const timezone = serverData && serverData.showTimeZoneMessage && !Tools.isCentralTimeZone() ? Tools.getCentralDateWithFormat(new Date(), "z") : "";
        const termsContent = serverData && serverData.covid19VaccineScheduleTerms ? serverData.covid19VaccineScheduleTerms : "";
        const vaccineMessage = (isFromSeeMore ? providerMessage: get(this.props, 'history.location.state.scheduleData.providerMessage')) || 'Vaccine Unspecified';
       
        return (
            <div className="row review-submission-container covid-vaccine-review-container" style={this.props.style}>
                <div className="col-12">
                    <div className="review-step__icon"><div className="svg-vaccine" /></div>
                    <h1 className="step-heading">You’re almost done! Do these details look correct?</h1>
                </div>
                <div className="col-12 review-details-container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-buttons">
                                <button type="button" className="btn btn-primary" onClick={() => { this.onGoNext()}}>YES, SCHEDULE NOW</button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="covid-vaccine-banner">
                                <h2 className="h5">Estimated Time & Day</h2>
                                <div className="review-details">
                                    <span>{appt.DayString} {appt.DateString}, {appt.timeString} {timezone}</span>
                                </div>
                                <div className="row covid-vaccine-info">
                                    <div className="col-12">
                                        <div className="details-icon-prepend">
                                            <div className="icon-col">
                                                <span className="icon-info-filled" />
                                            </div>
                                            <div className="details-col">Exact time will be provided once you schedule the appointment.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-12 col-xs-12 col-lg-6">
                            <h2 className="h5">Patient</h2>
                            <div className="review-details">
                                {patientName}
                            </div>
                            <div className="hr-divider" />
                        </div>

                        <div className="col-12 col-md-12 col-xs-12 col-lg-6">
                            <h2 className="h5">Reason for Visit</h2>
                            <div className="review-details">
                                {visit.visitType.description}
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-12 col-xs-12 col-lg-6">
                            <h2 className="h5">Location</h2>
                            <div className="review-details">
                                <a className={address ? "directions-link" : "no-link"} href={locationDirections} target={locationDirectionsTarget}>
                                    <span>{location}</span>
                                </a>
                            </div>
                            <div className="hr-divider" />
                        </div>
                        <div className="col-12 col-md-12 col-xs-12 col-lg-6">
                            <h2 className="h5">Vaccine</h2>
                            <div className="review-details">
                                {vaccineMessage}
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>
                    {visit && visit.patientInstructions && visit.patientInstructions.length > 0 &&
                        <div className="row covid-vaccine-instructions">
                            <div className="col-12">
                                <h2 className="h5">When You Arrive</h2>
                                <div className="review-details">
                                {visit.patientInstructions.map((item, index) => (
                                    <div key={index}><StaticHtmlContent content={item} /></div>
                                ))}
                                </div>
                                <div className="hr-divider" />
                            </div>
                        </div>
                    }

                    {termsContent &&
                        <div className="row">
                            <div className="col-12">
                                {termsContent}
                            </div>
                        </div>
                    }
                </div>
            </div>
            
        );
    }
}
export default withRouter(Covid19ReviewNSubmit);